export const initialProps = {
	featureAppId: 'vw-portal-dashboard',
	featureAppCitaId: 'es-oneform-cita-posventa-embedded',
};

export class Environment {
	private static _instance: Environment;
	public props: any = initialProps;

	private constructor(env: EnvironmentEnum) {
		const propertiesByEnv = {
			[EnvironmentEnum.LOCALHOST]: {
				bonusDetailPageId: 'my-bonus-detail-int',
				maintenancePage: 'maintenance-plan-int',
				digitalManualPage: 'DIMA_DigitalManual_Content',
				condicionesUsoClubVW: 'condiciones-club-volkswagen',
				garage: 'myvw_dashboard',
				vips: 'historias-volkswagen',
				derechosAseguradoPage: 'derechos-asegurado',
				longdrive: 'longdrive',
				ofertas: 'ofertas',
				gti50: 'gti-50',
				mastersCarretera: 'es-portal-master-carretera',
				laLiga: 'la-liga',
			},
			[EnvironmentEnum.INT]: {
				bonusDetailPageId: 'my-bonus-detail-int',
				maintenancePage: 'maintenance-plan-int',
				digitalManualPage: 'DIMA_DigitalManual_Content',
				condicionesUsoClubVW: 'condiciones-club-volkswagen',
				garage: 'myvw_dashboard',
				vips: 'historias-volkswagen',
				derechosAseguradoPage: 'derechos-asegurado',
				longdrive: 'longdrive',
				ofertas: 'ofertas',
				gti50: 'gti-50',
				mastersCarretera: 'es-portal-master-carretera',
				laLiga: 'la-liga',
			},
			[EnvironmentEnum.PRE]: {
				bonusDetailPageId: 'my-bonus-detail',
				maintenancePage: 'maintenance-plan',
				digitalManualPage: 'DIMA_DigitalManual_Content',
				condicionesUsoClubVW: 'condiciones-club-volkswagen',
				garage: 'myvw_dashboard',
				vips: 'historias-volkswagen',
				derechosAseguradoPage: 'derechos-asegurado',
				longdrive: 'longdrive',
				ofertas: 'ofertas',
				gti50: 'gti-50',
				mastersCarretera: 'es-portal-master-carretera',
				laLiga: 'la-liga',
			},
			[EnvironmentEnum.PRO]: {
				bonusDetailPageId: 'my-bonus-detail',
				maintenancePage: 'maintenance-plan',
				digitalManualPage: 'DIMA_DigitalManual_Content',
				condicionesUsoClubVW: 'condiciones-club-volkswagen',
				garage: 'myvw_dashboard',
				vips: 'historias-volkswagen',
				derechosAseguradoPage: 'derechos-asegurado',
				longdrive: 'longdrive',
				ofertas: 'ofertas',
				gti50: 'gti-50',
				mastersCarretera: 'es-portal-master-carretera',
				laLiga: 'la-liga',
			},
		};

		this.props = {
			...this.props,
			...propertiesByEnv[env],
		};
	}

	public static getInstance(env?: EnvironmentEnum) {
		let result = null;
		if (this && !this._instance && !env) {
			result = {
				props: {
					...initialProps,
				},
			};
		}
		result = this._instance || (this._instance = new this(env as EnvironmentEnum));

		return result.props;
	}
}

export enum EnvironmentEnum {
	LOCALHOST = 'LOCALHOST',
	INT = 'INT',
	PRE = 'PRE',
	PRO = 'PRO',
}
